module.exports = __webpack_public_path__ + "media/promotional/bachelorette-party-2d473c8b.jpg";